<template>
    <div style="background: white">
        <div class="bannerBox">
            <a-carousel :dot-position="bottom">
                <div>
                    <img class="bannerImg" src="@/assets/img/kcd.jpg" />
                </div>
            </a-carousel>
        </div>
        <div class="breadBox">
            <a-breadcrumb>
                <span>
                    <img src="@/assets/img/position.png" />
                    当前位置：
                </span>
                <a-breadcrumb-item @click="onRollbackHome" style="cursor:pointer">首页</a-breadcrumb-item>
                <a-breadcrumb-item>{{title}}</a-breadcrumb-item>
            </a-breadcrumb>
        </div>
        <div class="tabBox">
            <div class="tabNav">
                <!-- <li :class="{activeLi:tags=='j'}" @click="getDetail('j')">技术合同登记</li> -->
                <li :class="{activeLi:tags=='g'}" @click="getDetail('g')">科创贷管理办法</li>
                <li :class="{activeLi:tags=='sq'}" @click="getDetail('sq')">科创贷申请流程</li>
            </div>
            <div class="content" v-html="FlowContent"></div>
        </div>
    </div>
</template>
<script>
import { achievementFontInfo } from "@/api/achievementsService";

export default {
    name: "noticeDetail",
    components: { },
    data() {
        return {
            title: null,
            tags: 'g',
            noticeObj: {},
            FlowContent:""
        }
    },
    methods: {
        getDetail(e) {
            this.tags = e
            this.getAction({
                url: achievementFontInfo.detailFlow,
                params: { tags: e }
            }).then(res => {
               this.FlowContent = res.content
            })
        },
        onRollbackHome() {
            this.$router.push({
                path: "/knowledge/index",
                query: {
                    type: "首页"
                }
            })
        }
    },
    mounted() {
        this.title = this.$route.query.type
        this.getDetail('g')
    }
}
</script>
<style lang="less" scoped>
.bannerBox {
    position: relative;
    width: 100%;
    //margin-bottom: 20px;

    .bannerImg {
        width: 100%;
        height: 100%;
    }
}

.breadBox {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
    background: white;
}

.tabBox {
    width: 1200px;
    display: flex;
    margin: 0 auto;
    padding: 10px 0 20px 0;
    .tabNav{
        width: 200px;   
        li{
            display: flex;
            justify-content: center;
            align-items: center;
            width:100%;
            height:80px;
            font-size: 20px;
            cursor: pointer;
            border-bottom:1px solid #006eff;
            &:hover{
                transition: .3s;
                background: #006eff;
                color:#fff;
                border-bottom:1px solid #006eff
            }
        }
        .activeLi{
            background: #006eff;
            color:#fff;
            border-bottom:1px solid #006eff
        }
    }
    .title {
        text-align: center;
        font-size: 30px;
        color: #333;
    }

    .subtitle {
        font-size: 14px;
        text-align: center;
        margin-top: 30px;
        padding-bottom: 20px;
        color: #333;
        border-bottom: 1px solid #ccc;
    }

    .titlecontent {
        text-align: center;
        font-size: 16px;
        margin-top: 60px;
        font-weight: 600;
    }

    .content {
        flex: 1;
        font-size: 16px;
        line-height: 30px;
        text-indent: 30px;
    }
}
</style>
